import { apiProxyRequest } from "Api/apiProxyRequest";
import { ProjectSetting } from "Reducers/projectSettings";

export const loadProjectSettingRequest = (projectId: string) =>
  apiProxyRequest<ProjectSetting>(`/projects/${projectId}/settings`);
